import { render, staticRenderFns } from "./pageFourth.vue?vue&type=template&id=8c9c3168&scoped=true"
import script from "./pageFourth.vue?vue&type=script&lang=js"
export * from "./pageFourth.vue?vue&type=script&lang=js"
import style0 from "./pageFourth.vue?vue&type=style&index=0&id=8c9c3168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9c3168",
  null
  
)

export default component.exports